import { colors, fonts } from '@grupoboticario/flora-tokens/quemDisseBerenice/web/ds'

export const quemDisseBerenice = {
  colors,
  fonts,
}
